import { settings } from "../../../../settings/settings-util";
import { hasNoReason } from '../util/util';
import h from "virtual-dom/h";


export default class SurveyQuestionBuilder
{
    //#region Public Interface

    constructor(settings)
    {
        this._settings = settings;
    }

    initialize(store)
    {
        this._store = store;
    }

    buildQuestion(questionConfig, surveyId)
    {
        const questionClassName = this._settings.classNames.surveyQuestion || settings.classNames.surveyQuestion;
        const textClassName = this._settings.classNames.surveyQuestionText || settings.classNames.surveyQuestionText;
        const textId = `${surveyId}-question-text`;
        const buttonWrapClassName = this._settings.classNames.surveyQuestionButtonWrap || settings.classNames.surveyQuestionButtonWrap;

        const noClassName = this._settings.classNames.surveyQuestionNoButton || settings.classNames.surveyQuestionNoButton;
        const noDisabledClassName = this._settings.classNames.surveyQuestionNoButtonDisabled || settings.classNames.surveyQuestionNoButtonDisabled;

        const yesClassName = this._settings.classNames.surveyQuestionYesButton || settings.classNames.surveyQuestionYesButton;
        const yesDisabledClassName = this._settings.classNames.surveyQuestionYesButtonDisabled || settings.classNames.surveyQuestionYesButtonDisabled;

        const noProperties =
        {
            className: hasNoReason(this._settings, this._store) ? noClassName : noDisabledClassName,
            ariaDescribedBy: textId,
            href: '#',
            onclick: this.buildQuestionOnClick(questionConfig.NoLink.gradingReason),
            tabIndex: hasNoReason(this._settings, this._store) ? 0 : -1,
        };
        const yesProperties =
        {
            className: hasNoReason(this._settings, this._store) ? yesClassName : yesDisabledClassName,
            ariaDescribedBy: textId,
            href: '#',
            onclick: this.buildQuestionOnClick(questionConfig.YesLink.gradingReason),
            tabIndex: hasNoReason(this._settings, this._store) ? 0 : -1,
        };

        const no  = h("a", noProperties, questionConfig.NoLink.DisplayText);
        const yes = h("a", yesProperties, questionConfig.YesLink.DisplayText);

        const buttonWrap = h("div", { className: buttonWrapClassName }, [yes, no]);
        const questionText = h("div", { className: textClassName, id: textId }, questionConfig.title);

        return h("div", { className: questionClassName }, [questionText, buttonWrap]);
    }

    //#endregion



    //#region Helper Methods

    buildQuestionOnClick(reason)
    {
        return hasNoReason(this._settings, this._store) ?
            (e) => { this._store.dispatch({ type: "SURVEY_REASON_GIVEN", reason: reason }); } : null;
    }

    //#endregion
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/simple-feedback-overlay/src/builders/surveyQuestionBuilder.js